const randomString = () => Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);

export default randomString;
